import "./styles.css";

import React from "react";
import ReactDOM from "react-dom/client";
import {
  createRouter,
  RouterProvider,
} from "@tanstack/react-router";

import { routeTree } from "./routes/route-tree";
import { WebAppProvider } from "./app/app-provider";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WebAppProvider>
      <RouterProvider router={router} />
    </WebAppProvider>
  </React.StrictMode>,
);
